import { useState, useEffect } from 'react';
import Icon from '@material-ui/core/Icon';
import Table from '@components/Table';
import TextField from '@components/TextField';
import { useHistory } from "react-router-dom";
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import { apiClient } from '@services/api';
import SelectSearch from 'react-select';
import { darkSelectStyles } from '@utils/darkSelectStyles';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
};

const Approves = (props) => {
  document.title = `Aprovações de desconto - ${process.env.REACT_APP_NAME}`;

  const history    = useHistory();
  const isMobile   = useIsMobile();
  const [rows]     = useState([]);
  const [sellers, setSellers]           = useState([]);
  const [q, setQ]                       = useState('');
  const [v, setV]                       = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [mobileRows, setMobileRows]     = useState([]);
  const [mobileLoading, setMobileLoading] = useState(false);

  const getSellers = () => {
    apiClient.httpInstance.get(`/users?seller=true&status=true&pageSize=500`).then(response => {
      if (response.status === 200) {
        let options = [{ value: '', label: 'Todos' }];
        response.data.data.forEach((el) => options.push({ value: el.name, label: el.name }));
        setSellers(options);
      }
    }).catch(() => {});
  };

  const fetchMobile = () => {
    setMobileLoading(true);
    const params = new URLSearchParams({ to_approve: true, pageSize: 200 });
    if (q)            params.append('q', q);
    if (v)            params.append('v', v);
    if (statusFilter) params.append('status_filter', statusFilter);
    apiClient.httpInstance.get(`/budgets?${params.toString()}`).then(r => {
      setMobileRows(r.data?.data || []);
    }).catch(() => {}).finally(() => setMobileLoading(false));
  };

  useEffect(() => { getSellers(); }, []);
  useEffect(() => { props.setShowMenu(false); }, []);
  useEffect(() => { if (isMobile) fetchMobile(); }, [isMobile, q, v, statusFilter]);

  const approvalStatusLabel = {
    pending:  { text: 'Aguard. aprovação', color: '#F5C842' },
    approved: { text: 'Aprovado',          color: '#62DEC2' },
    refused:  { text: 'Recusado',          color: '#e05252' },
  };

  const approvalTypeLabel = (type, value) => {
    if (!type || !value) return '—';
    if (type === 'discount_pct')   return `${value}% desconto`;
    if (type === 'discount_value') return `R$ ${value} desconto`;
    if (type === 'installment')    return `${value}x sem juros`;
    return value;
  };

  const statusOptions = [
    { value: '',         label: 'Todos' },
    { value: 'pending',  label: 'Aguardando' },
    { value: 'approved', label: 'Aprovado' },
    { value: 'refused',  label: 'Recusado' },
  ];

  const filtersBar = (
    <div
      className="p-4 mt-4 border-1"
      style={{ background: '#172B4D', borderRadius: isMobile ? 10 : '10px 10px 0px 0px', borderColor: '#1e3a5a', marginBottom: isMobile ? 12 : 0 }}
    >
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center' }}>
        <TextField
          className="inputRounded"
          label="Referência ou cliente"
          variant="outlined"
          type="text"
          name="q"
          onChange={(ev) => setQ(ev.target.value)}
          InputProps={{ style: { color: '#e8f0fb', background: '#172B4D' } }}
          InputLabelProps={{ style: { color: '#8ba5c4' } }}
          style={{ minWidth: 200, flex: 1 }}
        />
        <div style={{ borderRadius: 20, border: '1px solid #1e3a5a', padding: '9px 0px', minWidth: 180, flex: 1 }}>
          <SelectSearch
            styles={customStyles}
            options={sellers}
            placeholder="Vendedor"
            value={v === '' ? { value: '', label: 'Vendedor' } : { value: v, label: v }}
            onChange={(ev) => setV(ev.value)}
          />
        </div>
        <div style={{ borderRadius: 20, border: '1px solid #1e3a5a', padding: '9px 0px', minWidth: 160, flex: 1 }}>
          <SelectSearch
            styles={customStyles}
            options={statusOptions}
            placeholder="Status"
            value={statusOptions.find(o => o.value === statusFilter) || statusOptions[0]}
            onChange={(ev) => setStatusFilter(ev.value)}
          />
        </div>
      </div>
    </div>
  );

  /* ── MOBILE VIEW ── */
  if (isMobile) {
    return (
      <div style={{ padding: '12px 16px', background: '#0f1e35', minHeight: '100vh' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
          <Icon style={{ color: '#F5C842', marginRight: 8 }}>pending_actions</Icon>
          <span style={{ color: '#e8f0fb', fontSize: 20, fontWeight: 700 }}>Aprovações</span>
        </div>

        {filtersBar}

        {mobileLoading ? (
          <div style={{ textAlign: 'center', padding: 40, color: '#8ba5c4' }}>Carregando...</div>
        ) : mobileRows.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 40, color: '#8ba5c4' }}>Nenhum registro encontrado.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {mobileRows.map((row) => {
              const info = approvalStatusLabel[row.approval_status];
              return (
                <div
                  key={row.id}
                  onClick={() => history.push({ pathname: `/admin/orcamentos/detalhe/${row.id}`, state: { approve: true } })}
                  style={{
                    background: '#172B4D', borderRadius: 12, padding: '14px 16px',
                    border: '1px solid #1e3a5a', cursor: 'pointer',
                  }}
                >
                  {/* Linha 1: referência + status */}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <span style={{ color: '#e8f0fb', fontWeight: 700, fontSize: 14 }}>{row.references}</span>
                    {info && (
                      <span style={{
                        color: info.color, fontWeight: 700, fontSize: 11,
                        padding: '2px 10px', borderRadius: 20,
                        border: `1px solid ${info.color}`, whiteSpace: 'nowrap',
                      }}>
                        {info.text}
                      </span>
                    )}
                  </div>

                  {/* Cliente */}
                  <div style={{ color: '#8ba5c4', fontSize: 13, marginBottom: 4 }}>
                    <span style={{ color: '#62DEC2', marginRight: 4 }}>Cliente:</span>
                    {row.customer_name || '—'}
                  </div>

                  {/* Pedido */}
                  <div style={{ color: '#F5C842', fontWeight: 700, fontSize: 13, marginBottom: 4 }}>
                    {approvalTypeLabel(row.approval_type, row.approval_value)}
                  </div>

                  {/* Justificativa */}
                  {row.approval_justify && (
                    <div style={{ color: '#8ba5c4', fontSize: 12, marginBottom: 6, fontStyle: 'italic' }}>
                      "{row.approval_justify}"
                    </div>
                  )}

                  {/* Rodapé: consultor + valor */}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 6, paddingTop: 8, borderTop: '1px solid #1e3a5a' }}>
                    <span style={{ color: '#8ba5c4', fontSize: 12 }}>
                      <Icon style={{ fontSize: 13, verticalAlign: 'middle', marginRight: 3 }}>person</Icon>
                      {row.user_name || '—'}
                    </span>
                    <NumberFormat
                      value={Number(row.total)}
                      displayType="text"
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale
                      thousandSeparator="."
                      isNumericString
                      prefix="R$ "
                      renderText={(v) => <span style={{ color: '#e8f0fb', fontWeight: 700, fontSize: 14 }}>{v}</span>}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  /* ── DESKTOP VIEW ── */
  return (
    <>
      <div className="px-7">
        <div className="flex items-center justify-between mt-2 text-2xl mb-3" style={{ color: '#e8f0fb' }}>
          <div className="flex items-center">
            <Icon className="mr-2" style={{ color: '#F5C842' }}>pending_actions</Icon>
            <span>Aprovações de desconto</span>
          </div>
        </div>

        {filtersBar}

        <Table
          path="/budgets"
          params={{ q, v, to_approve: true, status_filter: statusFilter }}
          onRowClick={(p) => history.push({ pathname: `/admin/orcamentos/detalhe/${p.row.id}`, state: { approve: true } })}
          columns={[
            {
              headerName: 'Referência',
              headerClassName: 'super-app-theme--header',
              field: 'references',
              flex: 1,
              minWidth: 120,
              renderCell: (params) => (
                <span style={{ color: '#e8f0fb', fontWeight: 600 }}>{params.row.references}</span>
              ),
            },
            {
              headerName: 'Cliente',
              headerClassName: 'super-app-theme--header',
              field: 'customer_name',
              flex: 1.5,
              minWidth: 140,
              renderCell: (params) => (
                <span style={{ color: '#e8f0fb' }}>{params.row.customer_name || '—'}</span>
              ),
            },
            {
              headerName: 'Pedido',
              headerClassName: 'super-app-theme--header',
              field: 'approval_type',
              flex: 1.2,
              minWidth: 140,
              renderCell: (params) => {
                const row = params.row;
                return (
                  <span style={{ color: '#F5C842', fontWeight: 700, fontSize: 14 }}>
                    {approvalTypeLabel(row.approval_type, row.approval_value)}
                  </span>
                );
              },
            },
            {
              headerName: 'Justificativa',
              headerClassName: 'super-app-theme--header',
              field: 'approval_justify',
              flex: 2,
              minWidth: 180,
              renderCell: (params) => (
                <span
                  title={params.row.approval_justify}
                  style={{ color: '#8ba5c4', fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '100%', display: 'block' }}
                >
                  {params.row.approval_justify || '—'}
                </span>
              ),
            },
            {
              headerName: 'Valor total',
              headerClassName: 'super-app-theme--header',
              field: 'total',
              flex: 1,
              minWidth: 110,
              renderCell: (params) => (
                <NumberFormat
                  value={Number(params.row.total)}
                  displayType="text"
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  thousandSeparator="."
                  isNumericString
                  prefix="R$ "
                  renderText={(v) => <span style={{ color: '#e8f0fb' }}>{v}</span>}
                />
              ),
            },
            {
              headerName: 'Consultor',
              headerClassName: 'super-app-theme--header',
              field: 'user_name',
              flex: 1,
              minWidth: 120,
              renderCell: (params) => (
                <span style={{ color: '#e8f0fb' }}>{params.row.user_name || '—'}</span>
              ),
            },
            {
              headerName: 'Status',
              headerClassName: 'super-app-theme--header',
              field: 'approval_status',
              flex: 1,
              minWidth: 180,
              headerAlign: 'right',
              align: 'right',
              renderCell: (params) => {
                const info = approvalStatusLabel[params.row.approval_status];
                return info ? (
                  <span style={{
                    color: info.color, fontWeight: 700, fontSize: 12,
                    padding: '4px 0', borderRadius: 20,
                    border: `1px solid ${info.color}`,
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    whiteSpace: 'nowrap', width: 150, textAlign: 'center',
                  }}>
                    {info.text}
                  </span>
                ) : null;
              },
            },
          ]}
          rows={rows}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({ user: state.user });
export default connect(mapStateToProps)(Approves);

const customStyles = {
  ...darkSelectStyles,
  menu: (provided, state) => ({
    ...darkSelectStyles.menu(provided, state),
    width: state.selectProps.width,
  }),
  control: (provided, state) => ({
    ...darkSelectStyles.control(provided, state),
    width: state.selectProps.width,
  }),
};
